export const PASSWORD_REQUIREMENTS_HINT =
  "At least 8 characters, including an uppercase letter, lowercase letter, number, and symbol.";

export const getPasswordValidationError = (password: string): string | null => {
  if (!password.trim()) {
    return "Please create a password";
  }

  if (password.length < 8) {
    return "Password must be at least 8 characters long";
  }

  if (!/[A-Z]/.test(password)) {
    return "Password must include at least one uppercase letter";
  }

  if (!/[a-z]/.test(password)) {
    return "Password must include at least one lowercase letter";
  }

  if (!/[0-9]/.test(password)) {
    return "Password must include at least one number";
  }

  if (!/[^A-Za-z0-9]/.test(password)) {
    return "Password must include at least one symbol (e.g. !@#$%)";
  }

  return null;
};

export const isPasswordValid = (password: string): boolean =>
  !getPasswordValidationError(password);
